import ajax from "../../ajax";
function authorize(params) {
  return new Promise((success, reject) => {
    ajax.post(`${window.envs.authTarget}/auth/user`, params).then(response => {
      if (response.data.success && response.data.content.status == "OK") {
        ajax.put("/auth", response.data.content).then(success).catch(reject);
      } else {
        reject(response.data);
      }
    }).catch(reject);
  });
}
export default {
  methods: {
    networkCreateRequestAuthToken() {
      return ajax.post("/auth");
    },
    networkCheckLogin(login) {
      return new Promise((success, reject) => {
        success({
          status: "ok"
        });
      });
    },
    networkCheckEmail(email) {
      return new Promise((success, reject) => {
        success({
          status: "ok"
        });
      });
    },
    networkRegisterUser(_ref) {
      let {
        login,
        email,
        password,
        token
      } = _ref;
      return authorize({
        type: 'register',
        method: 'password',
        token,
        props: {
          login,
          email,
          password
        }
      });
    },
    networkLoginUser(_ref2) {
      let {
        login,
        password,
        token
      } = _ref2;
      return authorize({
        type: 'login',
        method: 'password',
        token,
        props: {
          login,
          password
        }
      });
    },
    networkSwitchUser(_ref3) {
      let {
        id,
        token
      } = _ref3;
      return authorize({
        method: 'switch',
        token,
        props: {
          id
        }
      });
    },
    networkLogoffUser(_ref4) {
      let {
        id,
        currentUser
      } = _ref4;
      let logoffUser = () => {
        return ajax.delete(`${window.envs.authTarget}/auth/user`, {
          id
        });
      };
      if (currentUser) {
        return new Promise((success, reject) => {
          ajax.delete("/api/user", {
            id
          }).then(response => {
            logoffUser().then(success).catch(reject);
          }).catch(reject);
        });
      }
      return logoffUser();
    }
  }
};